import React from 'react';
import portfolioData from '../data/portfolioData';

const StackSection: React.FC = () => {
  const categories = [
    { key: 'frontend', label: 'Frontend & Mobile' },
    { key: 'backend', label: 'Backend' },
    { key: 'database', label: 'Base de données' },
    { key: 'devops', label: 'DevOps & CI/CD' },
    { key: 'design', label: 'UI/UX Design' },
    { key: 'languages', label: 'Langues' },
  ] as const;

  return (
    <section id="stack" className="section stack">
      <div className="container">
        <h2 className="section__title">Stack Technique & Langues</h2>
        <div className="section__divider" />

        {/* Tech categories */}
        <div className="stack__categories">
          {categories.map(({ key, label }) => (
            <div key={key} className="stack__category">
              <h3 className="stack__category-title">{label}</h3>
              <div className="stack__category-grid">
                {portfolioData.stack[key].map((tech, index) => (
                  <div key={index} className="stack__item">
                    <tech.icon size={18} />
                    <span>{tech.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* AI Workflow */}
        <div className="stack__ai">
          <h3 className="stack__ai-title">
             {portfolioData.aiWorkflow.title}
          </h3>
          <p className="stack__ai-desc">
            {portfolioData.aiWorkflow.description}
          </p>
          <div className="stack__ai-tools">
            {portfolioData.aiWorkflow.tools.map((tool, index) => (
              <span key={index} className="stack__ai-tool">
                {tool}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StackSection;